import firebase, { firebaseAdmin } from "./Firebase.service";
import firestoreService from "./FireStore.service";

const Teams = firestoreService.collection("v2_teams");

export const auth = firebase.auth();
export const admin_auth = firebaseAdmin.auth();

export const createTeam = (data) => {

    return Teams
        .doc( data.id )
        .set ( data ).then(() => {
            console.log('New Team has been added');
            return data;
        })
        .catch((error) => {
            console.log("Create Team failed",error);
            Promise.reject(error);
        })
}

export const updateTeam = (team) => {

  return Teams.doc(team.id)
    .set({ ...team }, { merge: true })
    .then(() => {
      console.log('team profile has been updated  ', team);
      return team;
    })
    .catch((error) => {
      console.log("team profile update failed",error);
      return Promise.reject(error);
    })
} 


export const getAllTeams = () => {

  return Teams
        .get()
        .then((querySnapshot) => {
            const data = querySnapshot.docs.map(doc => doc.data());
            console.log('all Teams',data);
        return data;
        }).catch((error) => {
          Promise.reject(error);
        });
    
}

export const getTeam = (uid) => {
  console.log('uid',uid);
  return Teams
        .doc(uid)
        .get()
        .then(documentSnapshot => {      
            if (documentSnapshot.exists) {
              return documentSnapshot.data();
            }
        }).catch((error) => {
            Promise.reject(error);
        })
}

export const deleteTeamById = (uid) => {
  console.log('uid',uid);
  return Teams
        .doc(uid)
        .delete()
        .then(() => {      
          console.log("Document successfully deleted!");
          return {
            id: uid,
            isDeleted: true
          };
        }).catch((error) => {
            Promise.reject(error);
        })
}
